import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { KindBoard } from 'src/utils/enums';

@Component({
    selector: 'cp-gauge',
    templateUrl: './cp-gauge.component.html',
    styleUrls: ['./cp-gauge.component.css'],
    standalone: false
})

export class CPGaugeComponent implements OnInit, OnChanges {
  @Input() value: number;
  @Input() startlegend: string;
  @Input() endlegend: string;
  @Input() percentual: number;
  @Input() Kind: KindBoard;
  strokeColor: string;
  radius = 44;
  circumference = 2 * Math.PI * this.radius;
  dashoffset: number;

  constructor() {
    this.cpgauge(0);
  }

  ngOnInit() {
    if (this.Kind) {
      if (this.Kind.valueOf() == KindBoard.Tarefa.valueOf()) {
        this.strokeColor = "#277099";
      }
      else {
        this.strokeColor = "#32285C";
      }
    }
    else {
      this.strokeColor = "#277099";
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.value?.currentValue !== changes.value?.previousValue) {
      this.cpgauge(changes.value.currentValue);
    }
  }

  private cpgauge(value: number) {
    value = this.validateValue(value);
    const progress = value / 100 / 2;
    this.dashoffset = this.circumference * (1 - progress);
  }

  private validateValue(value: number) {
    if (value > 100) {
      value = 100;
    }
    if (value < 0) {
      value = 0;
    }
    return value;
  }
}
